import React, { useContext, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { Spin } from "antd";
import { GlobalContext } from "./context/GlobalContext";

const PrivateRoute = ({ component: Component, ...rest }) => {
  const { user, loading } = useContext(GlobalContext);
  if (loading) {
    return <div className="spinner-overlay"></div>;
  }
  return user?.uuid !== '' ? <Component {...rest} /> : <Navigate to="/login" replace />;
};
export default PrivateRoute;
